import { useState, useEffect } from 'react';
import { LoginConfig } from '@/types/auth';
import useFetch from '@/hooks/useFetch';

export interface UseLoginConfigResult {
  config: LoginConfig | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useLoginConfig = (pathPrefix: string): UseLoginConfigResult => {
  const [config, setConfig] = useState<LoginConfig | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { doFetch } = useFetch();

  const fetchConfig = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const apiConfig: LoginConfig = await doFetch(`/auth/login-config/${pathPrefix}`);

      // Use the config directly from API - no conversion needed
      setConfig(apiConfig);
    } catch (err) {
      console.error('Error fetching login config:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');

      // No fallback - config must come from backend
      setConfig(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathPrefix]);

  return {
    config,
    isLoading,
    error,
    refetch: fetchConfig
  };
};

